import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Box, Typography, Button, Paper } from '@mui/material';
import { Home as HomeIcon, Error as ErrorIcon } from '@mui/icons-material';
import { useLanguage } from '../contexts/LanguageContext';

const NotFoundPage = () => {
  const { t, isArabic } = useLanguage();
  
  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          textAlign: 'center',
          direction: isArabic ? 'rtl' : 'ltr'
        }}
      >
        <Paper elevation={3} sx={{ p: 6, borderRadius: 3 }}>
          <ErrorIcon sx={{ fontSize: 100, color: 'error.main', mb: 2 }} />
          <Typography variant="h1" sx={{ fontSize: '4rem', fontWeight: 'bold', mb: 2 }}>
            404
          </Typography>
          <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
            {t('Page Not Found', 'الصفحة غير موجودة')}
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            {t(
              'The page you are looking for does not exist or has been moved.',
              'الصفحة التي تبحث عنها غير موجودة أو تم نقلها.'
            )}
          </Typography>
          <Button
            component={Link}
            to="/"
            variant="contained"
            size="large"
            startIcon={<HomeIcon />}
            sx={{
              px: 4,
              py: 1.5,
              fontSize: '1.1rem',
              textTransform: 'none'
            }}
          >
            {t('Return Home', 'العودة للصفحة الرئيسية')}
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

export default NotFoundPage;

